import { RemoteError } from '@/types/common/Rest';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const remoteError = (error: any): RemoteError => {
  let message = 'Erro interno do servidor';
  let code = 500;

  if (error.response.data && error.response.data.message) {
    message = error.response.data.message;
    code = error.response.data.status;
  } else if (
    error.response.data &&
    error.response.data.error &&
    error.response.data.error_description
  ) {
    message = error.response.data.error_description;
    code = error.response.status;
  } else if (error.response.status == 404) {
    message = '404 - Recurso indisponível';
  }
  return {
    message: message,
    code: code,
  } as RemoteError;
};
